import React from "react";
import { useNavigate } from "react-router-dom";
import { Facebook, Instagram, LinkedIn, YouTube } from "@mui/icons-material";
import { PUBLIC_BRAND_RED_OLIVE, PUBLIC_BRAND_STAYJADE } from "../../../constants/publicBrands";
import { buildBrandListingHref } from "../../../views/property-list/listingBranding";
import "./footer.css";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer-ref">
      <div className="foot-top-ref">
        <div className="foot-brand-ref">
          <button type="button" className="foot-logo-ref foot-btn-link" onClick={() => navigate("/")}>
            <img
              src={`${process.env.PUBLIC_URL}/images/image/logo.png`}
              alt="Jadecaps"
              className="foot-logo-img-ref"
              width={150}
              height={40}
              decoding="async"
            />
          </button>
          <p className="foot-about-ref">
            Asset-light hospitality platform managing leisure villas (StayJade) and urban apartments (Red Olive) across Bangalore, Goa, Hyderabad and Kolkata. Founded 2019, Bangalore.
          </p>
          <div className="foot-soc-ref">
            <a href="https://www.linkedin.com/company/jadecaps-technologies-pte-ltd/" target="_blank" rel="noreferrer" className="fsoc-ref" aria-label="LinkedIn"><LinkedIn fontSize="small" /></a>
            <a href="https://www.instagram.com/stayjade_blr" rel="noreferrer" className="fsoc-ref" aria-label="Instagram"><Instagram fontSize="small" /></a>
            <a href="https://www.facebook.com/jadecaps/" target="_blank" rel="noreferrer" className="fsoc-ref" aria-label="Facebook"><Facebook fontSize="small" /></a>
            <a href="https://www.youtube.com/channel/UCZzAxHIseSk-nepsA-HV_mw" target="_blank" rel="noreferrer" className="fsoc-ref" aria-label="YouTube"><YouTube fontSize="small" /></a>
          </div>
        </div>

        <div className="foot-col-ref">
          <div className="foot-col-h-ref">Our Brands</div>
          <ul className="foot-links-ref">
            <li><button type="button" className="foot-btn-link" onClick={() => navigate(buildBrandListingHref(PUBLIC_BRAND_STAYJADE))}>StayJade - Leisure Villas</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate(buildBrandListingHref(PUBLIC_BRAND_RED_OLIVE))}>Red Olive - Urban Stays</button></li>
          </ul>
          <div className="foot-col-h-ref foot-spacer-ref">Destinations</div>
          <ul className="foot-links-ref">
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/properties?city=Bengaluru")}>Bangalore</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/properties?city=Goa")}>Goa</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/properties?city=Hyderabad")}>Hyderabad</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/properties?city=Kolkata")}>Kolkata</button></li>
          </ul>
        </div>

        <div className="foot-col-ref">
          <div className="foot-col-h-ref">For Owners</div>
          <ul className="foot-links-ref">
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/list-your-property")}>List your property</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/list-your-property")}>How it works</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/list-your-property")}>NRI homeowners</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/list-your-property")}>Owner dashboard</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/list-your-property")}>Revenue calculator</button></li>
          </ul>
        </div>

        <div className="foot-col-ref">
          <div className="foot-col-h-ref">Company</div>
          <ul className="foot-links-ref">
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/about-us")}>About us</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/corporates")}>For Corporates</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/travel-agents")}>Travel agents</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/offers")}>Offers</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/blogs")}>Blogs</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/about-us")}>Press &amp; Media</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/career")}>Careers</button></li>
            <li><button type="button" className="foot-btn-link" onClick={() => navigate("/contact-us")}>Contact us</button></li>
          </ul>
          <div className="foot-col-h-ref foot-spacer-ref">Offices</div>
          <ul className="foot-links-ref">
            <li><span>Bangalore (HQ)</span></li>
            <li><span>Hyderabad - Goa - Kolkata</span></li>
          </ul>
        </div>
      </div>

      <div className="foot-bottom-ref">
        <span>&copy; {currentYear} Jadecaps Technologies Pvt. Ltd. - Koramangala, Bangalore 560034</span>
        <span>
          <button type="button" className="foot-btn-link" onClick={() => navigate("/page/privacy-policy")}>Privacy Policy</button>
          {" - "}
          <button type="button" className="foot-btn-link" onClick={() => navigate("/page/terms-and-conditions")}>Terms of Service</button>
          {" - "}
          <button type="button" className="foot-btn-link" onClick={() => navigate("/page/refund-cancellation-policy")}>Guest Policy</button>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
